import { graphql } from 'gatsby'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import React from 'react'
import Figure from 'react-bootstrap/Figure'

import { Cta } from '@/components/blocks-library/cta/cta'
import { resolveImageAttribution } from '@/utils/image-author'

import * as styles from './image-art-direction.module.scss'
type ImageCtaProps = Queries.ImageInlineFragment & {
  className?: string
}

const ImageCta: React.FC<ImageCtaProps> = ({ image, cta, className }) => {
  if (!image) return null
  const linkCta = cta?.[0] ?? null

  const { gatsbyImageData, alt, author, customData, title } = image
  const ImageComponent = (
    <GatsbyImage
      image={gatsbyImageData as unknown as IGatsbyImageData}
      alt={alt ?? linkCta?.text ?? ''}
      className={className ?? ''}
    />
  )
  const separator = Boolean(title) && Boolean(author) ? ` | ` : ''
  const photoBy = resolveImageAttribution(author, customData)
  const showCaption = Boolean(title) || Boolean(photoBy)
  return (
    <Figure className={styles.imageWithCaption}>
      {linkCta ? <Cta {...linkCta}>{ImageComponent}</Cta> : ImageComponent}
      {showCaption && (
        <Figure.Caption>
          {title} {separator}
          {photoBy && <span>Photo by {photoBy}</span>}
        </Figure.Caption>
      )}
    </Figure>
  )
}

export default ImageCta

export const query = graphql`
  fragment ImageInline on DatoCmsImage {
    __typename
    id: originalId
    image {
      gatsbyImageData(width: 1400)
      alt
      author
      customData
      title
    }
    cta {
      __typename
      ... on DatoCmsCta {
        ...Cta
      }
    }
  }
`
